const moment = require('moment')
const assinatura = {
  dados: {
    mensagem: 'Você está em uma avaliação gratuita.',
    mostraBarra: true,
    mostraLink: true,
    permitirNovaSimulacao: true,
    simulacoesRestantes: 5,
    ativa: false
  },
  assine () {
    this.dados.mensagem = 'Para completar a assinatura, são necessários alguns campos (*). Possui um cupom? Agora é a hora de usar.'
    this.dados.mostraBarra = true
    this.dados.mostraLink = false
  },
  gratis (total, restante) {
    let mensagem = `Você ainda possui ${restante} de ${total} simulações disponíveis.`
    if (restante <= 0) {
      mensagem = `Que pena, você usou as suas ${total} simulações grátis.`
      this.dados.permitirNovaSimulacao = false
    }
    this.dados.mensagem = `Você está em uma versão de experiência do BeefStats. ${mensagem}`
    this.dados.mostraBarra = true
    this.dados.mostraLink = true
    this.dados.simulacoesRestantes = restante
  },
  desativado () {
    this.dados.mensagem = 'Sua assinatura está desativada'
    this.dados.mostraBarra = true
    this.dados.mostraLink = true
  },
  vencida (restante){
    this.dados.mensagem = 'Sua assinatura está vencida.'
    this.dados.mostraBarra = true
    this.dados.mostraLink = true
    this.dados.simulacoesRestantes = restante
    this.dados.permitirNovaSimulacao = restante > 0
  },
  pendente (restante) {
    this.dados.mensagem = 'Sua assinatura está em revisão. Caso já tenha efetuado o pagamento, por favor aguarde. O processo pode levar até 3 dias úteis para estar liberado.'
    this.dados.mostraBarra = true
    this.dados.mostraLink = false
    this.dados.simulacoesRestantes = restante
    this.dados.permitirNovaSimulacao = restante > 0
  },
  pendente2 (expiraEm) {
    let hoje = moment().format('YYYY-MM-DD')
    let tempoRestante = moment(expiraEm).diff(hoje, 'days')
    this.dados.mensagem = `Sua assinatura está em revisão. Caso já tenha efetuado o pagamento, por favor aguarde. O processo pode levar até 3 dias úteis para estar liberado.`
    this.dados.mostraBarra = true
    this.dados.mostraLink = false
    this.dados.permitirNovaSimulacao = tempoRestante > 0
  },
  ativo () {
    this.dados.mensagem = ''
    this.dados.mostraBarra = false
    this.dados.mostraLink = false
    this.dados.permitirNovaSimulacao = true
    this.dados.ativa = true
  }
}

export default {
  assinatura
}



// WEBPACK FOOTER //
// ./src/services/Compartilhamento.js